// extracted by mini-css-extract-plugin
export default {"layout":"e80711115a _137c7c88e5 _24998c0a97","h_slide":"dbc48850b2","category":"ec1555218a _998a2e16f9 _8c796441b9"};